/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Branches_Field_NameInputs */

const en_branches_field_name = /** @type {(inputs: Branches_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branch name`)
};

const pt_br2_branches_field_name = /** @type {(inputs: Branches_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome da filial`)
};

/**
* | output |
* | --- |
* | "Branch name" |
*
* @param {Branches_Field_NameInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const branches_field_name = /** @type {((inputs?: Branches_Field_NameInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Branches_Field_NameInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_branches_field_name(inputs)
	return pt_br2_branches_field_name(inputs)
});